import { render, staticRenderFns } from "./StarredFolderIcon.vue?vue&type=template&id=9f05c848&scoped=true"
import script from "./StarredFolderIcon.vue?vue&type=script&lang=js"
export * from "./StarredFolderIcon.vue?vue&type=script&lang=js"
import style0 from "./StarredFolderIcon.vue?vue&type=style&index=0&id=9f05c848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f05c848",
  null
  
)

export default component.exports